import { Component, OnDestroy, OnInit } from '@angular/core';
import { RoleUser } from '../../../model/roleUser';
import { Subject, takeUntil } from 'rxjs';
import { Router } from '@angular/router';
import { OnlineService } from '../../../services/online.service';
import { ThemeService } from '../../../services/theme.service';
import { UserService } from '../../../services/user.service';
import { TranslateService } from '@ngx-translate/core';
import { SnackBarService } from '../../../services/snackBar.service';
import { SpinnerService } from '../../../services/spinner.service';
import { environment } from 'src/environments/environment';
import { AppTypeEnum } from '../../../model/appType';
import { User } from '../../../model/user';
import { GlobalStateService } from '../../../services/globalState.service';
import { DrawerService } from '../../../services/drawer.service';

@Component({
    selector: 'app-home-air',
    templateUrl: './home-air.component.html',
    styleUrls: ['./home-air.component.scss'],
    standalone: false,
})
export class HomeAirComponent implements OnInit, OnDestroy {

  timestampt: string;

  user = new User();

  selectedGroup: number;
  selectedApp: number;
  roles: RoleUser[];

  selectedComponent: string;
  airState: any;
  roouterPath: boolean;

  private destroy$ = new Subject<void>();

  constructor(
    private router: Router,
    private onlineService: OnlineService,
    private themeService: ThemeService,
    private userService: UserService,
    private translate: TranslateService,
    public snackBarService: SnackBarService,
    private spinnerService: SpinnerService,
    private globalStateService: GlobalStateService,
    private drawerService: DrawerService) {
      const currentProfile = userService.currentProfile;

      this.roles = currentProfile.profiles;
      this.selectedGroup = currentProfile.profiles
        .find(p => p.idGroup === currentProfile.idActiveProfile)?.idGroup;
    }

  ngOnInit(): void {
    localStorage.removeItem('filter');
    localStorage.removeItem('filter-equipment');
    localStorage.removeItem('customFields');
    this.timestampt = environment.timeStamp;

    this.user = this.userService.currentProfile;
    this.drawerService.close();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  goToPage(page: string): void {
    this.roouterPath = true;
    void this.router.navigateByUrl(page);
  }

  getTheme(): string {
    return this.themeService.getThemeHome(AppTypeEnum.AIR);
  }

  downloadData(): void {
    this.spinnerService.show();

    this.onlineService.downloadCacheableData().pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.snackBarService.sendSuccess(this.translate.instant('home.form.downloadDataOffline.ok') as string);

      this.spinnerService.hide();
    }, () => {
      this.snackBarService.sendError(this.translate.instant('home.form.downloadDataOffline.error') as string);

      this.spinnerService.hide();
    });
  }

  showExternalEquipments(): boolean {
    const currentUser = this.userService.currentProfile;

    if (currentUser == null) {
      return false;
    }

    return currentUser.showExternalEquipments;
  }

  showAir(): boolean {
    const currentUser = this.userService.currentProfile;

    if (currentUser === null || currentUser === undefined) {
      return false;
    }

    return currentUser.idActiveApp === AppTypeEnum.AIR;
  }

  getLogo(): string {
    return 'assets/img/qloud_air.png';
  }

  getText(): string {
    return 'landing.main.air';
  }

  getThemeIconPath(): string {
    return 'assets/icons/air/';
  }

  newProtocol(): void {
    void this.router.navigateByUrl('air/protocol?id=0');
  }

  newExecutions(): void {
    void this.router.navigateByUrl('air/execution?id=0');
  }

  newProtocolAir(): void {
    void this.router.navigateByUrl('/air/protocol?id=0');
  }

  newExecutionsAir(): void {
    void this.router.navigateByUrl('/air/execution?id=0');
  }

  newInternalEquipment(): void {
    void this.router.navigateByUrl('/air/internalEquipment?id=0');
  }

  newExternalEquipment(): void {
    void this.router.navigateByUrl('/air/externalEquipment?id=0');
  }

  newCalibration(): void {
    void this.router.navigateByUrl('/air/calibration?id=0');
  }

  newIsothermalCharacterization(): void {
    void this.router.navigateByUrl('/air/isothermalCharacterization?id=0');
  }

}
